/**
 * 全局反馈组件（架构 §2 src/components/common/Feedback.tsx / T10 / T16 / T21）
 *  - 监听 window 事件 'zhihui:feedback'（detail: { severity, text }）显示 Snackbar
 *  - socket/client.ts 在收到 error 事件（AI 相关错误码）或业务异常时派发
 *  - 该组件挂在 App 根部，全局可用
 */
import { useEffect, useState } from 'react';
import { Snackbar, Alert } from '@mui/material';
import { FEEDBACK_EVENT } from '../../socket/client';

interface FeedbackDetail {
  severity: 'info' | 'warning' | 'error';
  text: string;
}

export default function Feedback() {
  const [open, setOpen] = useState(false);
  const [detail, setDetail] = useState<FeedbackDetail>({ severity: 'info', text: '' });

  useEffect(() => {
    function onFeedback(e: Event) {
      const d = (e as CustomEvent<FeedbackDetail>).detail;
      if (d && d.text) {
        setDetail(d);
        setOpen(true);
      }
    }
    window.addEventListener(FEEDBACK_EVENT, onFeedback as EventListener);
    return () => window.removeEventListener(FEEDBACK_EVENT, onFeedback as EventListener);
  }, []);

  return (
    <Snackbar
      open={open}
      autoHideDuration={4000}
      onClose={() => setOpen(false)}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert severity={detail.severity} variant="filled" onClose={() => setOpen(false)}>
        {detail.text}
      </Alert>
    </Snackbar>
  );
}
